import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { getFacilitiesExportExcelDownload } from 'services/fund'

export default function useGetDownload(setTask, CheckMutate) {
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: string | undefined) => {
            return getFacilitiesExportExcelDownload(payload)
        },
        onSuccess: (data) => {
            //@ts-ignore
            setTask(data && data.task_id)
            //@ts-ignore
            CheckMutate(data.task_id)
        },
        onError: () => {
            toast.error('مشکلی پیش آمده!')
        },
    })
    return { mutate }
}
